import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-107c6818"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "register" }
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createTextVNode("DOCUMENT "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" MAKER")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Восстановление доступа", -1))
const _hoisted_5 = { class: "form" }
const _hoisted_6 = { style: {"width":"286px"} }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Введите E-mail с которым регистрировались (на него будет отправлен пароль)", -1))
const _hoisted_8 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginLogo = _resolveComponent("LoginLogo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_LoginLogo),
      _hoisted_3
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _withDirectives(_createElementVNode("input", {
          type: "email",
          placeholder: "nevis@yandex.ru",
          maxlength: "50",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event))
        }, null, 512), [
          [_vModelText, _ctx.email]
        ])
      ]),
      _createElementVNode("div", null, [
        (_ctx.step_next)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.send_pwd())),
              disabled: !_ctx.step_next,
              class: _normalizeClass({ active_btn: _ctx.step_next })
            }, " Отправить пароль на E-mail ", 10, _hoisted_8))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "button_back",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.go_back()))
      }, "Назад")
    ])
  ]))
}